/**
 * KitMembers are joins between kit and user within a space. They contain role & permission
 * information.
 */

import * as actionTypes from "../../actions/actionTypes";

const kitMemberReducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_KITS_SUCCESS: {
      const { userId, spaceId } = action,
        kits = action.response.entities.kits;
      if (!kits) return state;

      const kitMembers = Object.values(kits).reduce((obj, k) => {
        obj[`${spaceId}-${userId}-${k.kitId}`] = k.access;
        return obj;
      }, {});
      return Object.assign({}, state, kitMembers);
    }
    case actionTypes.DELETE_SPACE_MEMBERS_SUCCESS: {
      const { userId, spaceId } = action;

      return Object.entries(state)
        .filter(e => !e[0].startsWith(`${spaceId}-${userId}`))
        .reduce((st, e) => {
          st[e[0]] = e[1];
          return st;
        }, {});
    }
    case actionTypes.DISMISS_MODAL: {
      return Object.entries(state).reduce((newState, [id, val]) => {
        if (val.status === "active") {
          newState[id] = val;
        }
        return newState;
      }, {});
    }
    case actionTypes.FETCH_KIT_MEMBERS_SUCCESS:
    default: {
      try {
        const kitMembers = action.response.entities.kitMembers || {};
        return { ...state, ...kitMembers };
      } catch (error) {
        return state;
      }
    }
  }
};

export default kitMemberReducer;
